import {Banknote, FileStack} from "lucide-react";
import {PaymentHistory} from "./PaymentHistory.tsx";
import {EPP} from "./EPP.tsx";
import {SamTabedPage} from "../../../components/SamTabedPaged.tsx";
import {useAppraiserApi} from "../../../context/ApiContext.tsx";
import {useEffect, useMemo, useState} from "react";
import {AppraiserInfo, DEFAULT_APPRAISER} from "../../../api/ApiTypes.ts";
import {useParams} from "react-router-dom";
import {PaymentPageSkeleton} from "./PaymentPageSkeleton.tsx";

export interface PaymentsTabProps {
    appraiserInfo: any;
    refreshAppraiserData: () => Promise<void>;
}

export const Payments = () => {

    const { tabName } = useParams();
    const appraiserApi = useAppraiserApi();

    const [appraiserLoading, setAppraiserLoading] = useState(false);
    const [appraiserInfo, setAppraiserInfo] = useState<AppraiserInfo>(DEFAULT_APPRAISER);
    const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);


    const refreshAppraiserData = async() => {
        setAppraiserLoading(true);
        try {
            const appraiser = await appraiserApi.getMyAppraiserInfo();
            setAppraiserInfo(appraiser);
            determineTabIndex();
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setAppraiserLoading(false);
        }
    }

    const determineTabIndex = () => {

        if (!tabName) {
            return;
        }

        const index = tabs.findIndex(tab => tab.slug === tabName.toLowerCase());
        if (index !== -1) {
            setSelectedTabIndex(index);
        } else {
            setSelectedTabIndex(0);
        }
    }

    useEffect(() => {
        refreshAppraiserData();
    }, []);


    const tabs = useMemo(() => {
        return  [
            {
                name: 'Payment History',
                icon: <FileStack className="h-5 w-5" />,
                description: 'Search for payments',
                slug: 'payment-history',
                component: () =>
                    <PaymentHistory
                        appraiserInfo={appraiserInfo}
                        refreshAppraiserData={refreshAppraiserData}
                    />
            },
            {
                name: 'Stewart Enterprise Payments (EPP)',
                icon: <Banknote className="h-5 w-5" />,
                description: 'View your EPP account',
                slug: 'epp',
                component: () =>
                    <EPP
                        appraiserInfo={appraiserInfo}
                        refreshAppraiserData={refreshAppraiserData}
                    />
            },
        ];
    }, [appraiserInfo])

    if (!appraiserInfo) {
        return (
            <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4 mt-4">
                <h2 className="text-yellow-700 font-medium">Appraiser Not Found</h2>
                <p className="text-yellow-600 mt-1"> The requested appraiser could not be found.</p>
            </div>
        );
    }

    return (
        <>
            { appraiserLoading ?
                ( <PaymentPageSkeleton/> ) :
                (// Main container with responsive max-width and horizontal/vertical padding
                <div className="max-w-7xl mx-auto px-4 py-8">
                    {/* Header section with title and description */}
                    <div className="mb-8">
                        {/* Large, bold title text in dark gray */}
                        <h1 className="text-2xl font-bold text-slate-800 mb-4">Payment Information</h1>
                    </div>

                    <SamTabedPage
                        tabs={tabs}
                        selectedTabIndex={selectedTabIndex}
                        setSelectedTabIndex={setSelectedTabIndex}
                    />
                </div>
                )
            }
        </>
    );
};